module.exports = __webpack_public_path__ + "static/media/delete_forever.1d5dc07a.svg";